import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../services/security/auth.service';

export const maintenanceGuard: CanActivateFn = (): Observable<boolean> => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const http = inject(HttpClient);

  if (authService.currentUser?.role === 'admin') {
    return of(true);
  }

  return http.get<{ enabled: boolean }>('/maintenance/status').pipe(
    map((status) => {
      if (status.enabled) {
        router.navigate(['/maintenance']);
        return false;
      }
      return true;
    }),
    catchError(() => of(true)),
  );
};
